// import '@aws-amplify/ui-react/styles.css';
import { DataGrid } from '@mui/x-data-grid';

const videoDebugColumns = [
  //   { field: 'id', headerName: 'ID', width: 70 },
  { field: 'cameraAngle', headerName: 'cameraAngle', width: 100 },
  { field: 'carNum', headerName: 'carNum', width: 100 },
  { field: 'createdAt', headerName: 'createdAt', width: 80 },
  { field: 'crossStart', headerName: 'crossStart', width: 80 },
  { field: 'eventId', headerName: 'eventId', width: 80 },
  { field: 'greenFlag', headerName: 'greenFlad', width: 80 },
  { field: 'id', headerName: 'id', width: 80 },
  { field: 'owner', headerName: 'owner', width: 80 },
  { field: 'runId', headerName: 'runId', width: 80 },
  { field: 'sccaid', headerName: 'sccaid', width: 80 },
  {
    field: 'srcVideoFormattedName',
    headerName: 'srcVideoFormattedName',
    width: 80,
  },
  { field: 'streamUrl', headerName: 'streamUrl', width: 80 },
  { field: 'updatedAt', headerName: 'updatedAt', width: 80 },
  { field: 'username', headerName: 'username', width: 80 },
  { field: 'vidSource', headerName: 'vidSource', width: 80 },
];
export function VideoDebugTable({ rows }) {
  return (
    <DataGrid
      rows={rows}
      columns={videoDebugColumns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      density={'compact'}
    />
  );
}
